import { render } from "./RequestsComponent.vue?vue&type=template&id=0fa719a8&scoped=true"
import script from "./RequestsComponent.vue?vue&type=script&lang=js"
export * from "./RequestsComponent.vue?vue&type=script&lang=js"

import "./RequestsComponent.vue?vue&type=style&index=0&id=0fa719a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa719a8"]])

export default __exports__